import { InjectionToken, ValueProvider } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW');

export const BROWSER_PROVIDERS: ValueProvider[] = [
  {
    provide: WINDOW,
    useValue: window,
  },
];
